import type { AppConfig, ShellHeroLink } from './app-config.model';

/**
 * Returns true when the value is a non-empty http(s) URL safe for hero banner navigation.
 * Blocks javascript:, data:, and other non-http(s) schemes.
 */
export function isAllowedHttpUrl(value: unknown): value is string {
  if (typeof value !== 'string') {
    return false;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  try {
    const protocol = new URL(trimmed).protocol;
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}

/**
 * Maps S3-managed app config to the active locale hero link, if configured and allowed.
 */
export function resolveShellHeroLink(
  config: AppConfig | null | undefined,
  locale: 'en' | 'fr',
): ShellHeroLink | null {
  if (!config) {
    return null;
  }

  const linkUrl = locale === 'fr' ? config.frUrl : config.enUrl;
  const openInNewTab = config.openInNewTab ?? true;

  if (!isAllowedHttpUrl(linkUrl)) {
    return null;
  }

  return {
    url: linkUrl.trim(),
    openInNewTab: openInNewTab !== false,
  };
}
